export enum CarrierOperations {
    DELIVERY = 'delivery',
    ADOPTION = 'adoption',
}
